import {
    INITIAL_PROYECTOS_WELCOME,
    LOADING_WELCOME,
    INGRESO_WELCOME,
    IMAGES_WELCOME,
    CACHED_IMAGES,
    PROYECTOS_WELCOME,
    TEXTURES_WELCOME,
    LOADED_IMAGES_WELCOME,
    STEP_WELCOME
} from '../actions';

const INIT_STATE = {
    loaded: false,
    welcome: false,
    cachedImages: false,
    proyecto: {},
    textures: {},
    images: {},
    loadedImages: 0,
    step: 1,
    error: ''
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case INITIAL_PROYECTOS_WELCOME:
            return {
                ...state, proyecto: {}, error: ''
            };
        case IMAGES_WELCOME:
            return {
                ...state, images: {}, error: ''
            };
        case LOADING_WELCOME:
            return {
                ...state, loaded: action.payload, error: ''
            };
        case INGRESO_WELCOME:
            return {
                ...state, welcome: action.payload, error: ''
            };
        case CACHED_IMAGES:
            return {
                ...state, cachedImages: action.payload, error: ''
            };
        case PROYECTOS_WELCOME:
            return {
                ...state, proyecto: action.payload, error: ''
            };
        case TEXTURES_WELCOME:
            return {
                ...state, textures: action.payload, error: ''
            };
        case LOADED_IMAGES_WELCOME:
            return {
                ...state, loadedImages: action.payload, error: ''
            };
        case STEP_WELCOME:
            return {
                ...state, step: action.payload, error: ''
            };
        default:
            return {
                ...state
            };
    }
}